<template>
  <div class="page-content the-transcript-student">
    <div class="student-list">
      <div class="search-wrap">
        <div class="search-options-wrap">
          <div class="option-item">
            <div class="option-title">
              {{ $t('public.enrollmentGradeTitle') }}
            </div>
            <a-select
              allowClear
              showSearch
              v-model="enrollGrade"
              style="width: 100%"
              :placeholder="$t('public.enrollmentGradeTitle')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="getStudentDataSource"
            >
              <a-select-option
                v-for="(item, index) in gradeList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('public.currentGrade') }}</div>
            <a-select
              allowClear
              showSearch
              v-model="currentGrade"
              style="width: 100%"
              :placeholder="$t('public.currentGrade')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="getStudentDataSource"
            >
              <a-select-option
                v-for="(item, index) in currentGradeList"
                :key="index"
                :value="item.value"
              >
                {{ $t(`${item.label}`) }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('public.enrollmentTime') }}</div>
            <a-select
              allowClear
              showSearch
              v-model="year"
              style="width: 100%"
              :placeholder="$t('public.enrollmentTime')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="getStudentDataSource"
            >
              <a-select-option
                v-for="(item, index) in enrollmentYearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </div>

          <div class="search-wrap--input">
            <a-input-search
              :placeholder="
                $t('public.searchList', { content: $t('public.student_lower') })
              "
              enterButton
              class="search-input"
              v-model="searchModel"
              @search="getStudentDataSource"
            />
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <a-table
        size="middle"
        :rowKey="(record, index) => index"
        :loading="studentTableLoading"
        :dataSource="studentDataSource"
        :pagination="false"
        :rowClassName="
          (record) => (studentId === record.id ? 'selected-row' : '')
        "
        :customRow="
          (record) => {
            return {
              style: {
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  if (studentId === record.id) {
                    return
                  }
                  this.studentInfo = record
                  studentId = record.id
                },
              },
            }
          }
        "
      >
        <a-table-column
          :title="$t('public.studentId')"
          dataIndex="studentNo"
          :sorter="sorterStudentNo"
        ></a-table-column>

        <a-table-column
          :title="$t('public.name')"
          dataIndex="name"
          :sorter="sorterName"
        >
          <template slot-scope="name, record">
            {{ record.name }}
            <span
              class="name"
              :class="
                record.studentStatus == 3
                  ? 'QS'
                  : record.studentStatus == 4
                  ? 'DO'
                  : 'GRA'
              "
              v-if="
                record.studentStatus == 3 ||
                record.studentStatus == 4 ||
                record.studentStatus == 5
              "
              >{{
                record.studentStatus == 3
                  ? $t('public.quitSchool')
                  : record.studentStatus == 4
                  ? $t('public.dropOut')
                  : record.studentStatus == 5
                  ? $t('public.graduation')
                  : ''
              }}</span
            >
          </template>
        </a-table-column>

        <a-table-column
          :title="$t('public.englishName')"
          dataIndex="englishName"
          :sorter="sorterEnglishName"
        >
          <template slot-scope="englishName, record">
            {{ record.surname }} {{ record.givenName }} ({{
              record.englishName
            }})
          </template>
        </a-table-column>
      </a-table>
    </div>

    <div class="student-grade" v-if="!!studentId">
      <div class="search-wrap">
        <div class="grade-title">Transcript</div>
        <div class="search-options-wrap">
          <div class="option-item">
            <div class="option-title">{{ $t('public.academicYear') }}</div>
            <a-select
              showSearch
              v-model="academic"
              style="width: 100%"
              :placeholder="$t('public.academicYear')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
            >
              <a-select-option
                v-for="(item, index) in academicYearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('public.exam') }}</div>
            <a-select
              showSearch
              v-model="exam"
              style="width: 100%"
              :placeholder="$t('public.exam')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
            >
              <a-select-option
                v-for="(item, index) in examList"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>

          <div class="search-handles-wrap">
            <a-button
              :loading="exportLoading"
              type="primary"
              @click="exportTranscript"
            >
              {{ $t('handle.exportPDF') }}
            </a-button>
          </div>
        </div>
      </div>

      <div class="cover-header"></div>
      <div class="cover-content">
        <div class="table-title-wrap">
          <div class="table-title student-name">
            {{ studentInfo.name }} {{ studentInfo.surname }}
            {{ studentInfo.givenName }} ({{ studentInfo.englishName }})
          </div>
          <a-button type="primary" @click="updateRecord">
            {{ $t('public.updateRecord') }}
          </a-button>
        </div>

        <!-- 表格 -->
        <a-table
          size="middle"
          :rowKey="(record, index) => index"
          :loading="tableLoading"
          :dataSource="transcriptDataSource"
          :pagination="false"
        >
          <a-table-column
            :title="$t('public.averageScore')"
            dataIndex="averageScore"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          ></a-table-column>

          <a-table-column
            title="GPA"
            dataIndex="GPA"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          ></a-table-column>

          <a-table-column
            :title="$t('public.level')"
            dataIndex="level"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          ></a-table-column>
        </a-table>

        <a-alert
          style="margin-top: 20px"
          v-if="exam === 1 || exam === 3"
          :message="$t('grades.midGradeTip')"
          type="warning"
        />

        <div class="table-list-title">{{ $t('handle.detail') }}</div>

        <!-- 表格 -->
        <a-table
          size="middle"
          :rowKey="(record, index) => index"
          :loading="tableLoading"
          :dataSource="dataSource"
          :pagination="false"
        >
          <a-table-column
            :width="200"
            :title="$t('public.subject')"
            dataIndex="name"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          ></a-table-column>

          <a-table-column
            :width="140"
            :title="$t('public.teacher')"
            dataIndex="teacher"
          ></a-table-column>

          <a-table-column
            v-if="exam === 1 || exam === 3"
            :width="100"
            :title="$t('public.score')"
            dataIndex="score"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="score, record">
              {{ record.recordStatus === 4 ? 'N/A' : score }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('grades.attendance')"
            dataIndex="attendance"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="attendance, record">
              {{ record.recordStatus === 4 ? 'N/A' : attendance }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('grades.assignments')"
            dataIndex="assignments"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="assignments, record">
              {{ record.recordStatus === 4 ? 'N/A' : assignments }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('grades.participation')"
            dataIndex="participation"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="participation, record">
              {{ record.recordStatus === 4 ? 'N/A' : participation }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('grades.quiz')"
            dataIndex="quiz"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="quiz, record">
              {{ record.recordStatus === 4 ? 'N/A' : quiz }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('public.midterm')"
            dataIndex="midterm"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="midterm, record">
              {{ record.recordStatus === 4 ? 'N/A' : midterm }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('public.final')"
            dataIndex="final"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="final, record">
              {{ record.recordStatus === 4 ? 'N/A' : final }}
            </template>
          </a-table-column>

          <a-table-column
            v-if="exam === 2 || exam === 4"
            :width="100"
            :title="$t('public.cumulativ')"
            dataIndex="cumulativ"
            :customCell="
              () => {
                return {
                  class: 'title-font',
                }
              }
            "
          >
            <template slot-scope="cumulativ, record">
              {{ record.recordStatus === 4 ? 'N/A' : cumulativ }}
            </template>
          </a-table-column>

          <a-table-column
            :ellipsis="true"
            :title="$t('public.comments')"
            dataIndex="comments"
          ></a-table-column>
        </a-table>

        <div class="table-list-title">
          {{ $t('public.classAdvisorFeedback') }}
        </div>

        <a-table
          size="middle"
          :rowKey="(record, index) => index"
          :loading="feedbackTableLoading"
          :dataSource="feedbackDataSource"
          :pagination="false"
        >
          <a-table-column
            :title="$t('public.comments')"
            dataIndex="comments"
          ></a-table-column>
        </a-table>
      </div>
    </div>

    <a-modal
      :width="800"
      :title="$t('public.updateRecord')"
      v-model="modalVisible"
      :footer="null"
    >
      <a-collapse style="margin-top: -20px" :bordered="false">
        <a-collapse-panel
          v-for="(item, index) in recordDataSource"
          :key="index"
          :header="item.name"
        >
          <!-- 表格 -->
          <a-table
            size="middle"
            :rowKey="(record) => record.id"
            :loading="recordTableLoading"
            :dataSource="item.grades"
            :pagination="false"
          >
            <a-table-column
              :title="$t('public.score')"
              dataIndex="score"
              :customCell="
                () => {
                  return {
                    class: 'title-font',
                  }
                }
              "
            ></a-table-column>

            <a-table-column
              :width="400"
              :title="$t('public.comments')"
              dataIndex="comments"
            ></a-table-column>

            <a-table-column
              :title="$t('public.editor')"
              dataIndex="editor"
            ></a-table-column>

            <a-table-column
              :title="$t('public.submitTime')"
              dataIndex="createDate"
            ></a-table-column>
          </a-table>
        </a-collapse-panel>
        <a-collapse-panel
          key="teacher"
          :header="$t('public.classAdvisorFeedback')"
        >
          <!-- 表格 -->
          <a-table
            size="middle"
            :rowKey="(record) => record.id"
            :loading="recordTeacherTableLoading"
            :dataSource="recordTeacherDataSource"
            :pagination="false"
          >
            <a-table-column
              :width="400"
              :title="$t('public.comments')"
              dataIndex="comments"
            ></a-table-column>

            <a-table-column
              :title="$t('public.editor')"
              dataIndex="editor"
            ></a-table-column>

            <a-table-column
              :title="$t('public.submitTime')"
              dataIndex="createDate"
            ></a-table-column>
          </a-table>
        </a-collapse-panel>
      </a-collapse>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import qs from 'qs'

export default {
  data() {
    return {
      campusId: localStorage.getItem('campusId'),

      enrollGrade: undefined, //入学年级
      currentGrade: undefined, //在读年级
      year: undefined, //入学时间
      searchModel: '',

      // 学生
      studentTableLoading: false,
      studentDataSource: [],

      studentInfo: {},
      studentId: '',

      // 学年
      academic: undefined,
      // 考试
      exam: undefined,
      examInfo: {},

      // 成绩
      tableLoading: false,
      transcriptDataSource: [],
      dataSource: [],

      modalVisible: false,
      recordTableLoading: false,
      recordDataSource: [],
      recordTeacherTableLoading: false,
      recordTeacherDataSource: [],

      feedbackTableLoading: false,
      feedbackDataSource: [],

      exportLoading: false,
    }
  },

  computed: {
    ...mapGetters([
      'userId',
      'gradeList',
      'enrollmentYearList',
      'academicYearList',
      'examList',
      'currentGradeList',
    ]),
  },

  watch: {
    academic() {
      this.getDataSource()
      this.getFeedback()
    },
    exam(val) {
      for (const item of this.examList) {
        if (item.value === val) {
          this.examInfo = item
        }
      }
      this.getDataSource()
      this.getFeedback()
    },
    studentId() {
      this.getDataSource()
      this.getFeedback()
    },
  },

  created() {
    this.selectYearSemester()
    this.getStudentDataSource()
  },

  methods: {
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }

      // 默认考试
      if (month >= 9) {
        this.exam = this.examList[0].value
      } else if (month >= 6) {
        this.exam = this.examList[3].value
      } else if (month >= 3) {
        this.exam = this.examList[2].value
      } else {
        this.exam = this.examList[1].value
      }
    },

    // 学生
    getStudentDataSource() {
      this.studentTableLoading = true
      this.$http(this.$api.GETTEACHINGSTUDENTLIST, {
        campusId: this.campusId, // 学习中心ID
        name: this.searchModel, //学生姓名
        enrollGrade: this.enrollGrade, //入学年级
        currentGrade: this.currentGrade, //在读年级
        enrollDate: this.year, //入学时间
      }).then((r) => {
        this.studentDataSource = r.data || []
        this.studentTableLoading = false
        if (this.studentDataSource.length > 0) {
          this.studentInfo = this.studentDataSource[0]
          this.studentId = this.studentDataSource[0].id
        }
      })
    },

    // 学生科目成绩
    getDataSource() {
      if (this.academic && this.exam && this.studentId) {
        this.tableLoading = true
        if (this.exam === 2 || this.exam === 4) {
          this.$http(this.$api.GETTERMSTRANSCRIPTSFINAL, {
            academic: this.academic,
            semester: this.exam > 2 ? 2 : 1,
            studentId: this.studentId,
          }).then((r) => {
            // 总评
            if (
              toString.call(r.data.AverageScore) === '[object Null]' &&
              toString.call(r.data.GPA) === '[object Null]' &&
              toString.call(r.data.Level) === '[object Null]'
            ) {
              this.transcriptDataSource = []
            } else {
              this.transcriptDataSource = [
                {
                  id: 1,
                  averageScore: r.data.AverageScore
                    ? r.data.AverageScore
                    : r.data.AverageScore === 0
                    ? 0
                    : '',
                  GPA: r.data.GPA ? r.data.GPA : r.data.GPA === 0 ? 0 : '',
                  level: r.data.Level || '',
                },
              ]
            }

            this.dataSource = r.data.course || []

            this.dataSource = this.dataSource.map((item) => {
              return {
                ...item,
                participation: item.termsTranscripts
                  ? item.termsTranscripts.paticipatio
                  : '',
                assignments: item.termsTranscripts
                  ? item.termsTranscripts.assignme
                  : '',
                attendance: item.termsTranscripts
                  ? item.termsTranscripts.attendanc
                  : '',
                quiz: item.termsTranscripts ? item.termsTranscripts.quiz : '',
                midterm: item.termsTranscripts
                  ? item.termsTranscripts.midterm
                  : '',
                final: item.termsTranscripts ? item.termsTranscripts.final : '',
                cumulativ: item.termsTranscripts
                  ? item.termsTranscripts.cumulativ
                  : '',
                comments: item.termsTranscripts
                  ? item.termsTranscripts.comments
                  : '',
                gradeStatus: item.termsTranscripts
                  ? item.termsTranscripts.gradeStatus
                  : '',
                recordStatus: item.termsTranscripts
                  ? item.termsTranscripts.recordStatus
                  : '',
              }
            })

            this.tableLoading = false
          })
        } else {
          this.$http(this.$api.GETTRANSCRIPTBYSTUDENTID, {
            campusId: this.campusId, // 学习中心ID
            academic: this.academic,
            term: this.exam,
            studentId: this.studentId,
          }).then((r) => {
            // 总评
            if (
              toString.call(r.data.AverageScore) === '[object Null]' &&
              toString.call(r.data.GPA) === '[object Null]' &&
              toString.call(r.data.Level) === '[object Null]'
            ) {
              this.transcriptDataSource = []
            } else {
              this.transcriptDataSource = [
                {
                  id: 1,
                  averageScore: r.data.AverageScore
                    ? r.data.AverageScore
                    : r.data.AverageScore === 0
                    ? 0
                    : '',
                  GPA: r.data.GPA ? r.data.GPA : r.data.GPA === 0 ? 0 : '',
                  level: r.data.Level || '',
                },
              ]
            }

            this.dataSource = r.data.grades || []

            this.dataSource = this.dataSource.map((item) => {
              return {
                ...item,
                score: item.grade ? item.grade.score : '',
                comments: item.grade ? item.grade.comments : '',
                gradeStatus: item.grade ? item.grade.gradeStatus : '',
                recordStatus: item.grade ? item.grade.recordStatus : '',
              }
            })

            this.tableLoading = false
          })
        }
      }
    },

    updateRecord() {
      this.getTranscriptUpdateRecord()
      this.getUpdateRecordByStudentId()
      this.modalVisible = true
    },

    // 修改记录
    getTranscriptUpdateRecord() {
      this.recordTableLoading = true
      this.$http(this.$api.GETTRANSCRIPTUPDATERECORD, {
        campusId: this.campusId, // 学习中心ID
        academic: this.academic,
        term: this.exam,
        studentId: this.studentId,
      }).then((r) => {
        this.recordDataSource = r.data || []
        this.recordTableLoading = false
      })
    },

    getUpdateRecordByStudentId() {
      this.recordTeacherTableLoading = true
      this.$http(this.$api.GETUPDATERECORDBYSTUDENTID, {
        academic: this.academic,
        term: this.exam,
        studentId: this.studentId,
      }).then((r) => {
        this.recordTeacherDataSource = r.data || []
        this.recordTeacherTableLoading = false
      })
    },

    // 班主任评语
    getFeedback() {
      if (this.academic && this.exam && this.studentId) {
        this.$http(this.$api.GETBYVALIDFEEDBACK, {
          academic: this.academic,
          term: this.exam,
          studentId: this.studentId,
        }).then((r) => {
          this.feedbackDataSource = r.data
            ? [
                {
                  id: r.data.id,
                  comments: r.data.comments,
                },
              ]
            : []
        })
      }
    },

    exportTranscript() {
      this.$confirm({
        title: this.$t('report.exportReport'),
        content: '',
        onOk: () => {
          this.getTranscripts()
        },
        onCancel() {},
      })
    },

    // 获取学生成绩表
    getTranscripts() {
      this.exportLoading = true
      this.$axios({
        method: 'post',
        url: `${this.$config.baseURL}${this.$api.IMPORTTERMSTRANSCRIPTSFINAL}`,
        responseType: 'blob',
        data: qs.stringify({
          academic: this.academic,
          semester: this.exam,
          studentId: this.studentId,
        }),
      })
        .then((r) => {
          this.downloadFileByBlob(r.data)
        })
        .catch(() => {
          this.exportLoading = false
        })
    },

    // 流下载
    downloadFileByBlob(fileBlob) {
      let fileName = ''
      fileName = `学期成绩报告-${this.studentInfo.surname} ${this.studentInfo.givenName}(${this.studentInfo.englishName}).pdf`

      if ('msSaveOrOpenBlob' in navigator) {
        // 在IE中需要使用此方法
        window.navigator.msSaveOrOpenBlob(fileBlob, fileName)
      } else {
        let downloadLink = document.createElement('a')
        downloadLink.download = fileName
        downloadLink.href = URL.createObjectURL(fileBlob)
        downloadLink.style.display = 'none'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        window.URL.revokeObjectURL(downloadLink.href)
        document.body.removeChild(downloadLink)
      }

      this.$message.success(this.$t('public.successfullyExported'))
      this.exportLoading = false
    },
    //学号排序
    sorterStudentNo(a, b) {
      return (
        parseInt(a.studentNo.substring(a.studentNo.length - 3)) -
        parseInt(b.studentNo.substring(b.studentNo.length - 3))
      )
    },
    //英文排序
    sorterEnglishName(a, b) {
      return (a.englishName + '').localeCompare(b.englishName + '')
    },
    //中文排序
    sorterName(a, b) {
      return (a.givenName + '').localeCompare(b.givenName + '')
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.the-transcript-student {
  padding-top: 0;
  padding-bottom: 0;
  min-height: calc(~'100% - @{switchComponentsHeight}');
  display: flex;
  @timetableTypeWidth: 420px;
  .student-list {
    padding: 15px 0;
    margin-bottom: -30px;
    width: @timetableTypeWidth;
    padding-right: 10px;
    border-right: 1px solid @lineColor;
    .class-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .class-title {
        font-size: @titleFontSize;
        .back {
          font-size: 24px;
          cursor: pointer;
        }
      }
    }
  }
  .student-grade {
    padding: 15px 0 0;
    width: calc(~'100% - @{timetableTypeWidth}');
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    .grade-title {
      font-size: @titleFontSize;
    }

    .cover-header {
      border: 1px solid @lineColor;
      border-bottom: 0;
      background-color: @backColor;
      height: 8px;
      margin: 10px 10px 0;
    }

    .cover-content {
      flex-grow: 1;
      border: 1px solid @lineColor;
      padding: 20px 20px 30px;
      .table-title-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .table-title {
          font-size: @titleFontSize;
        }

        .student-name {
          font-weight: bold;
        }
      }
    }
  }
}
.table-list-title {
  font-size: @titleFontSize;
  margin: 25px 0 10px;
}
.modal-first-title {
  margin-top: -10px;
}
</style>

<style lang="less">
@import '../../style/variable.less';

.the-transcript-student {
  .title-font {
    font-size: @titleFontSize;
  }
  .selected-row {
    background-color: @selectBackColor;
    &:hover:not(.ant-table-expanded-row) > td {
      background-color: @selectBackColor;
    }
  }
  /deep/ .ant-table-tbody {
    .name {
      margin-left: 8px;
      display: inline-block;
      padding: 2px 3px;

      color: white;
      border-radius: 5px;
    }
    .GRA {
      background-color: #707070;
    }
    //休学
    .QS {
      background-color: #ff9933;
    }
    //退学
    .DO {
      background-color: #ff6666;
    }
  }
}
</style>
